import ChipSelector, { ChipOption } from "../../../../components/common/form/ChipSelect/ChipSelector";
import CustomText from "../../../../components/common/general/CustomText/CustomText";

export interface InterestsEditorProps {
  value: string[];
  onChange: (value: string[]) => void;
  showHeader?: boolean;
}
const interestOptions: ChipOption[] = [
  {
    key: "video_games",
    value: "Video Games",
    icon: <CustomText text="🎮" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "sports",
    value: "Sports",
    icon: <CustomText text="🏀" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "music",
    value: "Music",
    icon: <CustomText text="🎵" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "cooking",
    value: "Cooking",
    icon: <CustomText text="🍳" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "art_design",
    value: "Art & Design",
    icon: <CustomText text="🎨" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "travel",
    value: "Travel",
    icon: <CustomText text="✈️" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "movies_tv",
    value: "Movies & TV",
    icon: <CustomText text="🎬" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "reading",
    value: "Reading",
    icon: <CustomText text="📚" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "fitness",
    value: "Fitness",
    icon: <CustomText text="💪" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "technology",
    value: "Technology",
    icon: <CustomText text="💻" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "nature",
    value: "Nature",
    icon: <CustomText text="🌿" size="m" useTranslationText={false} style={undefined} />,
  },
  {
    key: "animals_pets",
    value: "Animals & Pets",
    icon: <CustomText text="🐾" size="m" useTranslationText={false} style={undefined} />,
  },
];

export default function InterestsEditor({ value, onChange, showHeader }: InterestsEditorProps) {
  return (
    <>
      {showHeader && (
        <CustomText style={{}} text="companion_onboarding_step1_title" useTranslationText size="l" weight="bold" />
      )}

      <ChipSelector options={interestOptions} selectedKeys={value ?? []} onSelectionChange={onChange} multiSelect />
    </>
  );
}
